import { MapStorePlugins } from "./plugins";

export const validate = (registeredPlugins: MapStorePlugins, configPlugins: string[]) => {
    return Object.keys(registeredPlugins).filter((plugin) => {
        return !configPlugins.includes(plugin);
    });
};
